export default "__VITE_ASSET__166df7b0__"